import api from './index';

export const paymentService = {
  /**
   * Create a Stripe checkout session
   */
  async createCheckoutSession(sessionData) {
    try {
      const response = await api.post('/payments?action=create-checkout-session', sessionData);
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  /**
   * Get payment status
   */
  async getPaymentStatus(paymentId) {
    try {
      const response = await api.get(`/payments?action=status&paymentId=${paymentId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting payment status:', error);
      throw error;
    }
  },

  /**
   * Get payment for application
   */
  async getApplicationPayment(applicationId) {
    try {
      const response = await api.get(`/payments?action=application&applicationId=${applicationId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      console.error('Error getting application payment:', error);
      throw error;
    }
  },

  /**
   * Get payment history for a user
   */
  async getPaymentHistory(userId) {
    try {
      const response = await api.get(`/payments?action=history&userId=${userId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return [];
      }
      console.error('Error getting payment history:', error);
      throw error;
    }
  },

  /**
   * Verify payment session (after Stripe redirect)
   */
  async verifySession(sessionId) {
    try {
      const response = await api.post('/payments?action=verify-session', { sessionId });
      return response.data;
    } catch (error) {
      console.error('Error verifying payment session:', error);
      throw error;
    }
  },

  /**
   * Process refund (admin function)
   */
  async processRefund(paymentId, refundData) {
    try {
      const requestData = {
        paymentId,
        ...refundData
      };
      const response = await api.post('/payments?action=refund', requestData);
      return response.data;
    } catch (error) {
      console.error('Error processing refund:', error);
      throw error;
    }
  },

  /**
   * Get payment statistics (admin function)
   */
  async getPaymentStats() {
    try {
      const response = await api.get('/payments?action=stats');
      return response.data;
    } catch (error) {
      console.error('Error getting payment stats:', error);
      throw error;
    }
  },

  /**
   * Get all payments (admin function)
   */
  async getAllPayments(limit = 50, offset = 0) {
    try {
      const response = await api.get(`/payments?action=list&admin=true&limit=${limit}&offset=${offset}`);
      
      // Ensure we return the payments array, not the wrapper object
      const data = response.data;
      if (data && data.payments && Array.isArray(data.payments)) {
        return data.payments;
      } else if (Array.isArray(data)) {
        return data;
      } else {
        console.warn('Unexpected response format from getAllPayments:', data);
        return [];
      }
    } catch (error) {
      console.error('Error getting all payments:', error);
      // Return empty array instead of throwing to prevent frontend crashes
      return [];
    }
  },

  /**
   * Create a temporary cart for pricing calculations
   */
  async calculatePrice(trademarkId, countries, classes) {
    try {
      const response = await api.post('/payments?action=calculate-price', {
        trademarkId,
        countries,
        classes
      });
      return response.data;
    } catch (error) {
      console.error('Error calculating price:', error);
      throw error;
    }
  },

  /**
   * Get receipt URL for a payment
   */
  async getReceiptUrl(paymentId) {
    try {
      const response = await api.get(`/payments?action=receipt&paymentId=${paymentId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting receipt URL:', error);
      throw error;
    }
  }
};

export default paymentService;
